var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78313 11.7943L6.21867 9.08716C5.92001 8.83844 5.92847 8.4107 6.23678 8.17173C6.49846 7.9689 6.88719 7.97478 7.14117 8.18543L9.5 10.7132L11.8588 8.18543C12.1128 7.97478 12.5015 7.9689 12.7632 8.17173C13.0715 8.4107 13.08 8.83844 12.7813 9.08716L10.2169 11.7943C10.2169 11.7943 9.9237 12.0234 9.5 12.0234C9.0763 12.0234 8.78313 11.7943 8.78313 11.7943Z",
    fill: "#626262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78313 11.7943L6.21867 9.08716C5.92001 8.83844 5.92847 8.4107 6.23678 8.17173C6.49846 7.9689 6.88719 7.97478 7.14117 8.18543L9.5 10.7132L11.8588 8.18543C12.1128 7.97478 12.5015 7.9689 12.7632 8.17173C13.0715 8.4107 13.08 8.83844 12.7813 9.08716L10.2169 11.7943C10.2169 11.7943 9.9237 12.0234 9.5 12.0234C9.0763 12.0234 8.78313 11.7943 8.78313 11.7943Z",
    fill: "#69707D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.106fa6edc0c75b644a56b67aca096730.svg";
export { ForwardRef as ReactComponent };